import { api } from "@/lib/api";
import type { ScopedParams } from "./common";
import type { HighlightsDto } from "@/types/api";

export const highlightsApi = {
  get: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<HighlightsDto>("/api/highlights", { leagueId, tournamentId }),
};
